module.exports = __webpack_public_path__ + "img/mo-zm-1.5e273ae7.png";